import { takeEvery, call, put } from 'redux-saga/effects';
import { GET_GLOBAL_SETTINGS, SET_GLOBAL_SETTINGS } from '../actions';
import { appId, apiUrl, deliveryId, pickupId, cateringId, reservationId } from "../components/Helpers/Config";
import cookie from 'react-cookies';
import Axios from 'axios';

export const watchGetSettings = function* () {
  yield takeEvery(GET_GLOBAL_SETTINGS, workerGetSettings);
}

function* workerGetSettings() {
  try {
	var availabilityId = (cookie.load("defaultAvilablityId") === undefined || cookie.load("defaultAvilablityId") === '' )?'':cookie.load("defaultAvilablityId");
	var orderPostalCode = (cookie.load('orderPostalCode') === undefined || cookie.load("orderPostalCode") === '' )?'':cookie.load("orderPostalCode");
	var orderOutletId = (cookie.load('orderOutletId') === undefined || cookie.load("orderOutletId") === '' )?'':cookie.load("orderOutletId");
	var posCdParm = (orderPostalCode !== '') ? "&postal_code=" + orderPostalCode : '';
	var avltyParm = (availabilityId !== '') ? "&availability=" + availabilityId : '';
	var outletParm = (orderOutletId !== '') ? "&outlet_id=" + orderOutletId : '';
    	
    const uri = apiUrl+'settings/get_common_settings?app_id='+appId+avltyParm+outletParm+posCdParm;
    const result = yield call(Axios.get, uri);
	cookie.save("deliveryOption", "No");
	cookie.save("pickupOption", "No");
	cookie.save("cateringOption", "No");
	cookie.save("reservationOption", "No");
	if (result.data.status === "ok") {
		var resultSet = result.data.result_set;
		availabilityId = (availabilityId !== '') ? availabilityId : resultSet.ninja_pro_default_availability_id;
		var availability = resultSet.availability;
		var availabilityLen = availability.length
		for (var i = 0; i < availabilityLen; i++) {
			if (availability[i].availability_id === deliveryId) {
				cookie.save("deliveryOption", "Yes");
			}
			if (availability[i].availability_id === pickupId) {
				cookie.save("pickupOption", "Yes");
			}
			if (availability[i].availability_id === cateringId) {
				cookie.save("cateringOption", "Yes");
			}
			if (availability[i].availability_id === reservationId) {
				cookie.save("reservationOption", "Yes");
			}
		}
	}
	availabilityId = (availabilityId !== '') ? availabilityId : deliveryId;
	cookie.save("defaultAvilablityId",availabilityId);
	var resultArr = [];
	resultArr.push(result.data);
    yield put({ type: SET_GLOBAL_SETTINGS, value: resultArr });
  } 
  catch {
    console.log('Get Settings Failed');
  }
} 
